import { selectEntities, select, selectAll } from './applicationSelectors';

export const selectUserEntities = selectEntities('users');
export const selectUsers = selectAll(selectUserEntities);
export const selectUser = select(selectUserEntities);
export const selectUserFromComment = (state, comment) => selectUser(state, comment.author_id);
